/**
 * LOCAL (DEVICE) STATE TYPES
 * ---------------------------------------------------------------------------
 * Everything in this file lives ONLY on the device (localStorage / memory).
 * It never round-trips to the Server and must never be mixed into
 * `types/server`. Identity, points, strikes etc. are Server state.
 */

export type ThemeMode = "system" | "light" | "dark";

/** Accent themes; some are unlocked by behavior-point thresholds (Server-verified). */
export type AccentTheme = "default" | "neon-sapphire" | "emerald-fleet";

export interface ThemeState {
  mode: ThemeMode; // dark is the product default
  accent: AccentTheme;
}

export interface UIPreferences {
  theme: ThemeState;
  /** Dyslexia-friendly font + increased tracking across the whole app. */
  dyslexiaFont: boolean;
  /** Sensory-overload friendly: disables vibration/sound triggers. */
  hapticsEnabled: boolean;
  audioFeedbackEnabled: boolean;
  notifications: NotificationPreferences;
}

export interface NotificationPreferences {
  academic: boolean; // "New Homework Added", "Timetable Room Changes"
  extracurricular: boolean; // "Club Announcements", "Fixture Changes"
  /**
   * "New Merit/De-merit Logged" — muting hides the popup only; point changes
   * still update the Trophy Cabinet silently (Server-side).
   */
  behavior: boolean;
}

export const DEFAULT_PREFERENCES: UIPreferences = {
  theme: { mode: "dark", accent: "default" },
  dyslexiaFont: false,
  hapticsEnabled: true,
  audioFeedbackEnabled: true,
  notifications: { academic: true, extracurricular: true, behavior: true },
};
